import { broadcastNodeCategories } from './BroadcastNodeTypes';
import type { WorkflowChannel } from '@/types';

interface Props {
  channel: WorkflowChannel;
  onDragStart: (event: React.DragEvent, nodeType: string) => void;
}

export function BroadcastSidebar({ channel, onDragStart }: Props) {
  const categories = broadcastNodeCategories(channel);

  return (
    <div className="w-52 shrink-0 border-r bg-background flex flex-col h-full overflow-y-auto">
      <div className="px-4 pt-4 pb-3 border-b">
        <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">Componentes</p>
      </div>

      <div className="p-3 space-y-2">
        {categories.map((node) => {
          const Icon = node.icon;
          return (
            <div
              key={node.type}
              draggable
              onDragStart={(e) => onDragStart(e, node.type)}
              className="flex items-center gap-3 p-2.5 rounded-lg border border-gray-200 bg-white cursor-grab hover:border-gray-300 hover:shadow-sm transition-all active:cursor-grabbing"
              title={`Arrastar: ${node.label}`}
            >
              <div className={`p-1.5 rounded-md text-white shrink-0 ${node.color}`}>
                <Icon className="w-3.5 h-3.5" />
              </div>
              <div className="min-w-0">
                <p className="font-medium text-xs leading-tight">{node.label}</p>
                <p className="text-[10px] text-muted-foreground leading-tight mt-0.5 truncate">{node.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
